import React, { useState, useEffect, useRef } from 'react';
import { Pencil, Loader2, AlertCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { userService } from '../../_services';
import '../../mysqpaymentform.css';
import CartItem from './CartItem';
import { GoogleSpreadsheet } from "google-spreadsheet";

const PaymentForm = ({ productsData, paymentFormData, cartItems, gotoAddressForm, handlePaymentSuccess, gotoCart }) => {
    const [errormsg, setErrormsg] = useState('');
    const [loader, setLoader] = useState(false);
    const [squareLoading, setSquareLoading] = useState(true);
    const [totalCartPrice, setTotalCartPrice] = useState('');
    const cardContainerRef = useRef(null);

    // Polls until window.Square is available (loaded from index.html script tag)
    const waitForSquare = () => new Promise((resolve, reject) => {
        if (window.Square) { resolve(); return; }
        let attempts = 0;
        const interval = setInterval(() => {
            attempts++;
            if (window.Square) {
                clearInterval(interval);
                resolve();
            } else if (attempts >= 50) { // 5 seconds max
                clearInterval(interval);
                reject(new Error('Square.js did not load in time'));
            }
        }, 100);
    });

    useEffect(() => {
        setSquareLoading(true);
        userService.GetPaymentStuff('')
            .then(async (apidata) => {
                if (apidata.length > 0) {
                    try {
                        await waitForSquare();

                        // Always read window.Square.payments fresh (not from the stale prop)
                        const paymentForm = window.Square.payments(apidata[0].applicationId, apidata[0].locationId);
                        let card;
                        try {
                            card = await initializeCard(paymentForm);
                        } catch (e) {
                            console.error('Initializing Card failed', e);
                            return;
                        }

                        setSquareLoading(false);

                        // card-button is always in the DOM, so addEventListener works reliably
                        document.getElementById('card-button').addEventListener('click', async (event) => {
                            await handlePaymentMethodSubmission(event, card, apidata[0].locationId);
                        });
                    } catch (error) {
                        console.error('Square init error:', error);
                        setErrormsg('Payment Failed! Please try later');
                        setLoader(false);
                        setSquareLoading(false);
                    }
                } else {
                    setSquareLoading(false);
                }
            });
    }, []);

    const initializeCard = async (payments) => {
        let card = await payments.card();
        await card.attach(cardContainerRef.current);
        return card;
    };

    const tokenize = async (paymentMethod) => {
        setErrormsg('');

        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === 'OK') {
            return tokenResult.token;
        } else {
            setErrormsg(tokenResult.errors[0].message);
            throw new Error(`Tokenization failed: ${JSON.stringify(tokenResult.errors)}`);
        }
    };

    const handlePaymentMethodSubmission = async (event, paymentMethod, locationId) => {
        event.preventDefault();
        setLoader(true);

        try {
            const token = await tokenize(paymentMethod);
            const idempotency_key = uuidv4();
            let userMeta = window.atob(localStorage.getItem('ajs_user_id'));
            let userId = userMeta.split(':')[0];
            let userName = userMeta.split(':')[1];

            await createPayment(userId, userName, idempotency_key, token);
            displayPaymentResults('SUCCESS');
        } catch (e) {
            setLoader(false);
            displayPaymentResults('FAILURE');
        }
    };

    useEffect(() => {
        if (cartItems) {
            const calculatedPrice = cartItems.reduce((a, b) => {
                return a + parseFloat(b.selectedPrice.QuantityPrice);
            }, 0)
            setTotalCartPrice(parseFloat(calculatedPrice).toFixed(2))
        }
    }, []);

    const GetGooglesheetEntry = (orderId, date) => {
        //const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
        //const SHEET_ID = process.env.REACT_APP_SHEET_ID;
        //const CLIENT_EMAIL = process.env.REACT_APP_GOOGLE_CLIENT_EMAIL;
        //const PRIVATE_KEY = process.env.REACT_APP_GOOGLE_SERVICE_PRIVATE_KEY;Commented because not in use

        let getlogin = window.location.href;

        const orderRows = cartItems.map((item) => {
            return { OrderID: orderId, Date: date, FirstName: productsData.Fname, LastName: productsData.Lname, Group_Number: productsData.GroupNumber?.toString(), Email: productsData.Email, Address1: productsData.Address1, Address2: productsData.Address2, City: productsData.City, State: productsData.State, Zip: productsData.Zip?.toString(), CardsQuantity: '-', CardType: '-', Phone: productsData.PhoneNo?.toString(), ProductName: item.ProductName, ProductId: item.ProductID, Price: item.selectedPrice.QuantityPrice, Quantity: item.selectedPrice.QuantityThreshold, Pharmacy: item.selectedPharmacy?.Name ? item.selectedPharmacy.Name : '-', Size: item.selectedSize?.Size ? item.selectedSize.Size : '-' }
        })

        if (getlogin.toLowerCase().includes("release-backoffice") || getlogin.toLowerCase().includes("dev-backoffice") || getlogin.toLowerCase().includes("localhost:") || getlogin.toLowerCase().includes("shadcn-backoffice")) {
            const doc = new GoogleSpreadsheet("1JZS0igMTpHBLZ_la4W0rKvrrb32SNvGAgAjjf3fJ4C8");
            const appendSpreadsheet = async (row) => {
                try {
                    await doc.useServiceAccountAuth({
                        client_email: "google-spread-sheet@cohesive-idiom-332408.iam.gserviceaccount.com",
                        private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC/+TBrXzEDSGqQ\nPpXZnhB6kr+h9mz16cntIP1a9w4lWUSmNeThFRy0xAfZOrSBj4BhNkrOmYbVvr47\nwFQg+KurLAqjJg9duJoygR79UPAYjVuiHuHAllXDlr3vHwjPsPs/kBR8uq/5Typ3\n8opPVZGVNgv4D9Jg5I+4457SyJTpN/7GxcpUuWks+k/HpCLRT3zhsDhJdIavQBI3\ngFOn0VpsU1YLC0iKppm07saMv9st2mfBJ4dUHVgAP70Sd8X0b/4rhTh2hveVoDnf\nYUwOy8CgqpLhpkiNgu8nXJh9ozjOPQdwYqpycgoRgYnejD8U31D2gKxCwQ4yGwpK\na1adQPJDAgMBAAECggEACRLEhJajsOWHz9h9aaMsYTa1YvjMLpVFq3T/NIDvxLki\n4v4yGqdOS4bmXhCFvofjR/TydTBRbKHOyPEuqL5IEteKiyp92G6krxVmOw/LwUVR\nGuj9v4X7eLqTsI0VdAeH4Hm1Vi3WqmBg//lRKy2+q0A6MZfB2D2FQ3ZSp+C+FQWw\n4TVRFZVG8TYOIziMuJqkr+UwMYL2OLw6XjqCMloIzgGmZt4gDNSPAR25yJBFVswk\n/Hh4mPXQpNSnn6qQetT7YTqC1inxfg7tZ1aOHXOfs5hCN//v0XPpgx1Tlg0cJiyt\nmm9EdDNg3+fA6BlyfoSwfvng/6TATt3/w/XvogoSCQKBgQDDu6op8crLqXcPDXZ2\nEZdB2GuSSk0eNzpcg6y7OBGjP3cql7SvTkhCOa593zUTDU6bac59E5QIQBD1jGLb\n7Qb8zXwYnjBsipX+BrbMubJaaD3ImsbpcipNsK+zPZsViaE9UbcFSN6Ii3w2lVH/\nkvo12cYWyue6uQUpTrYUH3YMOQKBgQD7FSy113nqS0V8ioRLQPMs5nvkDF1bhKvn\nqpSKr/JdinY7W9Kosc0k4wl/PhZ2tsJH2RuLehDtWNlTa0nWczoLTxXjVTHq314V\nJT38QNS07IRHAvcGEECf5B0dK87t5UoHRPz6tHqU4YAyMq1JDla+qFSZZF1mg26s\nIjR8zRNqWwKBgQCNePIYWRy0MevNJHTwB+zk+dFernepFFAJmF7b/z24WeH/FiHR\n5+oQe/KkJhYNjDu51zMZcnI3uF7JrEu0HFFFnhxJCuWDPnQFZMLxnHLOJ7Qob76/\n8vWiq8eC7U9PtOenE44Ossmttev0496dtJVHIP2tccEmVB7n6W1vhAHl+QKBgDZg\nKpOi+6sq6/yBvw7RHRjfPXtw1hMI03XTcmHqotFxOBO42hFgmC3h4V+mIZVKFR8c\nPKPjJqFQOZigRphj0fE7CmF2RN45y5VGwHrNy4L3Kdp7IOY2RNibvVZg82p/2p1i\namsdBOMTRwEYCoEk0tJtgAzMOJIH6sLqkXVpsEe7AoGBAJb/UDJdwSLY0ERyUiry\niNl1fVr3oswGMRyuSfpAHjpAd1rLDs3gOFP28vDCUL1I766jbApaJGygkCjvxmxQ\nGWIdndYxFcrAak0eqy2ZP8qFH0qZA7JKqNSIhw8fCCZ8F54LceKVAHdSOxL+i4b+\nLcc5g+vfgvViBdJWSAd1DHFf\n-----END PRIVATE KEY-----\n"
                    });
                    // loads document properties and worksheets
                    await doc.loadInfo();
                    const sheet = doc.sheetsById["0"]; //Commented because not in use
                    //const result = await sheet.addRow(row); //Commented because not in use
                    await sheet.addRows(row)
                } catch (e) {
                    console.error('Error: ', e);
                }
            };
            /*const newRow = [{ OrderID: orderid1, Date: this.state.date, FirstName: this.state.Fname, LastName: this.state.Lname, Group_Number: gn1, Email: this.state.Email, Address1: this.state.Address1, Address2: this.state.Address2, City: this.state.City, State: this.state.State, Zip: this.state.Zip, CardsQuantity: this.state.quantity, CardType: this.state.cardStyle }]*/
            //appendSpreadsheet(newRow);
            appendSpreadsheet(orderRows);
        }
        else {
            const doc = new GoogleSpreadsheet("1WdcHyaZGax6Bpo6sY7r6vbRaiOuZBsC-aJkAWntYIHo");
            const appendSpreadsheet = async (row) => {
                try {
                    await doc.useServiceAccountAuth({
                        client_email: "paymententry@crafty-key-333107.iam.gserviceaccount.com",
                        private_key: "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCZXP7jo93HHaaU\n3vqbnHxAnbjRcBoTnNJhsnJRIkEQGjOZAwfQJdTjIjsEHuPf0W0m02DRSj47S2l7\ngTWtkirkTdCQO48z8t4r8wG4yG5/GplAZz1vLc4Mfmv4WRSYdDoCVAtFeqSQGWwH\nsvjplxiGppGnLILl08FsEG3PBrU8uv0E6Sgrv8Al453XaJrI2T38uvxG15yIyZYl\nyGYMpD4HLxpWcZqRH3GIqDg5gBndkd34zcwDW6TYQEvf+XWnSeE8Rvf1JlXOFho+\nmOdU1IE+ETvmEwll6F01okKoRuvC67IfkmuGiieENXRve7NLncqPYUwX2TiE7H2X\n9CctJVYFAgMBAAECggEAG8xOayadoWTPd/Z+yEvx/ahZAqVmJJ3tSEYXEHu7/VYy\neg6hkOn6j3z544JR3ZTRSxNPXkAtzYOayAcgmqh+28j6/9m72Deya5btfffeh21j\nz9emvAs6aOtVWLuUzxlqFlfzfxF+2JuzCCY5leWMTYPNrNaVl2Dtk0/bB4Z4vVwD\nX4X9NFShUEIQzghlrFGdht1nztluOX+1ZGnhfhf5FfbZtSlOR3UlUuSjvaEWMAhg\nghHru/s8PMdsDusTMRv3tgjbLac70nTYsmOdw7eIaEM16WeU0McHSNsaA7h8Nm7u\nsyS38HpgvDlRF6uWDq8qD1x8HSGhORVTLEQWEDEYNQKBgQDSpwjysfYjW77Kx17v\nB0ZYViroV1RHEPXLxhbPT4z+x7eor8KW7JtHSnKUY5bnuswbYq6Sq/vjizH8V8Hq\nFvdI+YyXzU+mBB0Hjat/4PDp8IDFQ/Gte7fVHIFYlqmHO9pUfZqPjqqnTVBOj0a3\nYLGcoFD+NTcCZkrbokFrvesmFwKBgQC6YMcAIYqQHslcudo5BtTS5CfuQnTOoJS8\nV3oemCofHgV4Ps8uCa/16s8yNwAQpMD21kpfYVpGyQtGicQICUhtPtu1uOMW7924\n0eShM4LIa9nnexHnCbi1cXTQUdMvPBGJCLZuAz60+p3qkZjgiuNe6Dhr2VRMWDPv\nNL/vhDFSQwKBgQCpr9QNbD2SDf2K6z8V3Q5ValP2BSLmfEsDcvY82SACvG69e5eM\na9xJeTcDQZX15Qs1pDBsBg5KJX6Gf0q9fvKD3kHappBac0XPJ9fWkyR9zjZssWal\nENvs16F58yNsxFIDbYpryci+LBFctx2H6mQofxu/Kq69SBlVA0cfu0UI0QKBgHjD\nto5GLYN+/1i+8ECdRY+02I7QruEoOdfkErP6QujQyhiFEjexfTuqP0E5VCh0qLgI\nWD5/VUCiilTVdZkDctOetDyGpVa6a/+SuUMennKBN7t/CjWbHf0rm9ZT/rQPhwk1\nBQg5wAsCjQpt9xIfzH41mEGBm9awHE617lwjWtYDAoGBAKSQ8+sa/YelAXcqc2J/\nUQ5Bqf7z0mxUCMIrtAc1Vt7V+xXlCHAG050adXZJ56tSqHVOINn4xn7ZU0yjxkEg\nRUYLahOK4jjBIrSZLZe0Osyu/HoD6o3VxlE/PJVX9Ag2xSgJL28JLBSN/5JOh+0v\nF1Hjm/gg+H17pFSNHRNQVv+6\n-----END PRIVATE KEY-----\n"
                    });
                    // loads document properties and worksheets
                    await doc.loadInfo();

                    const sheet = doc.sheetsById["0"]; //Commented because not in use
                    //const result = await sheet.addRow(row);Commented because not in use
                    await sheet.addRows(row)
                } catch (e) {
                    console.error('Error: ', e);
                }
            };
            /*const newRow = [{ OrderID: orderid1, Date: this.state.date, FirstName: this.state.Fname, LastName: this.state.Lname, Group_Number: gn1, Email: this.state.Email, Address1: this.state.Address1, Address2: this.state.Address2, City: this.state.City, State: this.state.State, Zip: this.state.Zip, CardsQuantity: this.state.quantity, CardType: this.state.cardStyle }];*/
            //appendSpreadsheet(newRow);
            appendSpreadsheet(orderRows);
        }

    }

    const createPayment = async (userId, userName, idempotency_key, source_id) => {
        setErrormsg('');

        const SelectedProducts = cartItems.map((item) => {
            return {
                ProductId: item.ProductID,
                Quantity: item.selectedPrice?.QuantityThreshold?.toString() || '',
                Size: item.selectedSize?.Size?.toString() || '',
                Pharmacy: item.selectedPharmacy?.Name || ''
            }
        })

        await userService.MarketPlaceProcessOrder(
            userId.toString(), userName, idempotency_key, source_id, productsData.Fname, productsData.Lname, productsData.Address1, productsData.Address2, productsData.State, productsData.City, productsData.Zip?.toString(), productsData.Email, productsData.GroupNumber?.toString(), productsData.PhoneNo?.toString(), SelectedProducts
        ).then(async (apidata) => {
            if (apidata.length > 0 && apidata[0].code === "-1") {
                setErrormsg('Payment failed: ' + apidata[0].message);
            } else {
                let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                let apptype = Usermeta_Data.split(':')[0]
                await userService.GoogleSheetEntry(apptype)
                    .then(
                        async (apidata) => {
                            if (apidata.length > 0) {
                                try {
                                    await GetGooglesheetEntry(apidata[0].orderId, apidata[0].date)
                                }
                                catch (error) { }
                            }
                        });
                handlePaymentSuccess();
            }
            setLoader(false);
        }).catch(() => {
            setErrormsg('Payment failed. Please try again.');
            setLoader(false);
        });
    };

    const displayPaymentResults = (status) => {
        const statusContainer = document.getElementById('payment-status-container');
        statusContainer.classList.toggle('is-success', status === 'SUCCESS');
        statusContainer.classList.toggle('is-failure', status === 'FAILURE');
        statusContainer.style.visibility = 'visible';
    };

    const uuidv4 = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    return (
        <div className="container payment-container mb-8">
            <link rel="stylesheet" type="text/css" href="mysqpaymentform.css" />
            <div className="shipping p-4 rounded-lg bg-secondary relative">
                <h3 className="font-bold">Shipping Address</h3>
                <p>
                    {productsData.Fname}  {productsData.Lname}
                    <br></br> {productsData.Address1}{productsData.Address2 ? ', ' + productsData.Address2 : ''}<br></br> {productsData.City}{productsData.State ? ', ' + productsData.State : ''}
                    <br></br>{productsData.Zip}
                </p>
                <h3 className="mt-2.5 font-bold">Group Number</h3>
                <p>{productsData.GroupNumber}</p>
                <div 
                    className="change absolute top-5 right-5 cursor-pointer flex items-center gap-1.5" 
                    onClick={gotoAddressForm}
                >
                    <Pencil size={16} />
                </div>
            </div>
            <div className="shipping p-4 rounded-lg bg-secondary relative mt-4">
                <h3 className="font-bold">Cart Product(s)</h3>
                <div 
                    className="change absolute top-5 right-5 cursor-pointer flex items-center gap-1.5" 
                    onClick={gotoCart}
                >
                    <Pencil size={16} />
                </div>
                <ul className="cart-items space-y-3 mt-4">
                    {cartItems.map((item, index) => (
                        <CartItem
                            key={index}
                            item={item}
                            readOnly={true}
                        />
                    ))}
                </ul>
            </div>
            <h3 className="font-bold mt-6 mb-4">Payment Information</h3>
            <div className="sq-payment-form">
            <div id="form-container">
                {squareLoading && (
                    <div className="flex items-center justify-center py-4">
                        <Loader2 className="h-8 w-8 animate-spin text-accent" />
                    </div>
                )}
                {/* sq-ccbox and card-button are always visible in the DOM so that:
                    1. Square can call card.attach() on a visible element
                    2. document.getElementById('card-button').addEventListener() always finds the element */}
                <div id="sq-ccbox" className="sqbox">
                    <form id="payment-form">
                        <div id="card-container" ref={cardContainerRef}></div>
                    </form>
                    <div id="payment-status-container"></div>
                </div>

                <Button
                    id="card-button"
                    disabled={loader}
                    className="mt-4 w-full h-12 bg-accent hover:!bg-accent text-white font-bold text-base"
                >
                    {loader && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
                    Pay ${totalCartPrice}
                </Button>

                {errormsg && (
                    <Alert variant="destructive" className="mt-4">
                        <AlertCircle className="h-4 w-4" />
                        <AlertDescription>{errormsg}</AlertDescription>
                    </Alert>
                )}
            </div>
            </div>{/* end sq-payment-form */}
        </div>
    );
};

export default PaymentForm;
